module.exports = __webpack_public_path__ + "img/shOn.07958c5a.svg";